import {create} from 'zustand';
import {ChangeLocationStore} from './types';

const useChangeLocationDialogStore = create<ChangeLocationStore>(set => ({
	changeLocationDialog: false,
	setChangeLocationDialog: value => set({changeLocationDialog: value}),
}));

export {useChangeLocationDialogStore};
